var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectedNewProduct = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8872 8.03245L13.9298 5.04297L4.18105 14.7917L3.18188 18.7907L7.18084 17.7904L16.8872 8.03245Z",
    stroke: "#007C92",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9297 5.04205L15.3952 3.57653C15.5124 3.45822 15.6519 3.36431 15.8056 3.30022C15.9593 3.23612 16.1242 3.20312 16.2907 3.20312C16.4572 3.20312 16.6221 3.23612 16.7758 3.30022C16.9295 3.36431 17.069 3.45822 17.1861 3.57653L19.2486 5.66424L16.8871 8.03382",
    stroke: "#007C92",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53174 14.4492L7.53153 17.449",
    stroke: "#007C92",
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectedNewProduct);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SelectedNewProduct.10fb3351a68b98e6b4c6fa6084c7d9b2.svg";